import JPStandardParser from "./parsers/JPStandardParser.js";
import JPMergeDateRangeRefiner from "./refiners/JPMergeDateRangeRefiner.js";
import JPCasualDateParser from "./parsers/JPCasualDateParser.js";
import { Chrono } from "../../chrono.js";
import { ParsingResult, ParsingComponents, ReferenceWithTimezone } from "../../results.js";
import { Meridiem, Weekday } from "../../types.js";
export { Chrono, ParsingResult, ParsingComponents, ReferenceWithTimezone };
export { Meridiem, Weekday };
export const casual = new Chrono(createCasualConfiguration());
export const strict = new Chrono(createConfiguration());
export function parse(text, ref, option) {
    return casual.parse(text, ref, option);
}
export function parseDate(text, ref, option) {
    return casual.parseDate(text, ref, option);
}
export function createCasualConfiguration() {
    const option = createConfiguration();
    option.parsers.unshift(new JPCasualDateParser());
    return option;
}
export function createConfiguration() {
    return {
        parsers: [new JPStandardParser()],
        refiners: [new JPMergeDateRangeRefiner()],
    };
}
//# sourceMappingURL=index.js.map